import React, { useEffect, useState } from "react";
import { Hidden, Row, Col, Container } from "react-grid-system";
import db from '../../Utils/firebase';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import "react-lazy-load-image-component/src/effects/blur.css";
import { showLoader, hideLoader } from "./../../components/common/Loader";
import FeatureCard from "../../components/common/FeatureCard";
import ContactCTA from "../../components/common/ContactCTA";
import Fade from 'react-reveal/Fade';
import SectionTitle from "../../components/common/SectionTitle";

const About = () => {

    const [aboutinfo, setAboutInfo] = useState();
    const [skillList, setSkills] = useState([]);

    useEffect(() => {
        showLoader();
        FetchAboutdata()

    }, [])

    const FetchAboutdata = async () => {

        await db.collection('root_collection').doc('some_document').collection('About').get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    // setlist(doc.data().title);
                    setAboutInfo(doc.data())
                });
                hideLoader();
            });

        await db.collection('root_collection').doc('some_document').collection('Skills').get()
            .then(querySnapshot => {
                let arr = [];
                setSkills(arr)
            });
    }


    return (
        <section className="section section-about section-about-1">
            <div className="display-spacing">
                {/* <Container> */}
                <Row>
                    {/* <Hidden xs sm md> */}
                    <Col lg={5}>
                        {/* <LoadingSpinner /> */}
                        <Fade left>
                            <div className="about-image">
                                <div className="image overlay-image">
                                    {window !== 'undefine' && window.innerWidth > 1024 ?
                                        <LazyLoadImage
                                            alt="about"
                                            effect="blur"
                                            src="/assets/images/intro/gopi-intro1.webp"
                                            style={{ borderRadius: '2rem' }}
                                        />
                                        :
                                        <LazyLoadImage
                                            alt="about"
                                            effect="blur"
                                            src="/assets/images/intro/gopi-intro1.webp"
                                            style={{ borderRadius: '2rem' }}
                                        />}
                                </div>
                            </div>
                        </Fade>
                    </Col>
                    {/* </Hidden> */}
                    <Col lg={7}>
                        {aboutinfo?.aboutUs &&
                            <Fade right>
                                <div className="about-content">
                                    <SectionTitle label="About us" title={aboutinfo?.userName} align="left" />
                                    <p>Focused senior professional with 7+ years of experience in mobile and web application development, specializing in React Native and React for cross-platform solutions.
<br/><br/>I have strong experience collaborating with founders, product managers, and technical teams throughout the complete development lifecycle—problem analysis, requirement clarification, system design, development, testing, and production deployment.
<br/><br/>In recent years, I have integrated AI-assisted development tools into my workflow to improve development speed, code quality, and decision-making—while maintaining strict standards for reliability, performance, and maintainability.
<br/><br/>I am fully experienced in end-to-end mobile app delivery, from early-stage planning to long-term maintenance of production applications used by real users.</p>
                                        {/* <p dangerouslySetInnerHTML={{ __html: aboutinfo?.aboutUs }} ></p> */}
                                </div>
                            </Fade>
                        }
                    </Col>
                </Row>

                {/* Feature Cards Section */}
                <Container>
                    <Fade bottom>
                        <FeatureCard containerStyle={{ marginTop: '3rem', marginBottom: '2rem' }} />
                    </Fade>
                </Container>
                
                <ContactCTA />
                {/* </Container> */}
            </div>
        </section>
    );
}

export default About;
